// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"3d1cb171","191":"261e3bc9","219":"b9168069","222":"0fb0008a","281":"dfd600e1","344":"f747559b","433":"d50ed344","453":"b6d51235","490":"9c31c369","539":"bfd9d037","606":"4e1fe766","635":"798ad042","826":"11b3ae99","968":"06534dbc"}[chunkId] + ".chunk.js";
};